import { useDispatch, useSelector } from "react-redux";
import { loadFaqList, setModalContent } from "./actions";
import { getFaqList, getLoadFaqReqInfo, getModalContent } from "./selectors";

export function useFaq() {
	const dispatch = useDispatch();

	return {
		loadFaqList: () => dispatch(loadFaqList()),
		setModalContent: (content) => dispatch(setModalContent(content)),

		faqList: useSelector(getFaqList),
		loadFaqListReqInfo: useSelector(getLoadFaqReqInfo),
		modalContent: useSelector(getModalContent),
	};
}
